import { render } from "./RewardValue.vue?vue&type=template&id=c69f60d2&scoped=true"
import script from "./RewardValue.vue?vue&type=script&lang=js"
export * from "./RewardValue.vue?vue&type=script&lang=js"

import "./RewardValue.vue?vue&type=style&index=0&id=c69f60d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c69f60d2"]])

export default __exports__